export enum NotificationStatus {
  None = 0,
  InReview,
  Published,
  InComplete,
  All
}
